<template>
    <div>
        <div class="position-fixed vh-100 d-none d-lg-flex flex-column p-3 sidebar">
            <ul class="nav nav-pills flex-column mb-4 flex-grow-1 mt-8">
                <li class="nav-item mb-2 text-white" v-for="item in sidebarItems" :key="item.name">
                    <router-link :to="item.link" class="nav-link text-white" active-class="active">
                        <h6><i :class="'fs-4 ' + item.icon"></i>&nbsp; {{ item.name }}</h6>
                    </router-link>
                </li>
            </ul>
            <div class="mt-auto pt-3 border-top text-white">
                Powered by
                <a href="#" target="blank"
                    class="text-white">
                    Stepping Stones</a>
            </div>
        </div>

        <div class="offcanvas offcanvas-start text-white" tabindex="-1" id="offcanvasSidebar"
            aria-labelledby="offcanvasSidebarLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasSidebarLabel">
                    Admin Dashboard
                </h5>
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                    aria-label="Close"></button>
            </div>
            <div class="offcanvas-body d-flex flex-column p-3">
                <ul class="nav nav-pills flex-column mb-4 flex-grow-1">
                    <li class="nav-item mb-2" v-for="item in sidebarItems" :key="item.name">
                        <router-link :to="item.link" class="nav-link text-white" active-class="active"
                            @click="closeOffcanvas">
                            <i :class="'fs-4 ' + item.icon"></i>&nbsp; {{ item.name }}
                        </router-link>
                    </li>

                    <li class="nav-item mb-2 mt-3 border-top pt-3 ml-1">
                        <button class="btn text-white d-flex align-items-center nav-link" @click="logout">
                            <i class="bi bi-box-arrow-right fs-4 me-2"></i> Logout
                        </button>
                    </li>
                </ul>
                <div class="mt-auto pt-3 border-top text-white">
                    Powered by
                    <a href="#" target="blank"
                        class="text-white">Stepping
                        Stones</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Offcanvas } from "bootstrap"; // Import the Offcanvas class from Bootstrap

export default {
    name: "sidebar-page",
    data() {
        return {
            sidebarItems: [],
            apiUrl: process.env.VUE_APP_API_BASE_URL,
            loggedIn: false,
            email: "",
            toggleBoxVisible: false,
        };
    },
    mounted() {
        const storedObject = localStorage.getItem("loginresponse");
        const loginResponse = JSON.parse(storedObject);
        console.log(loginResponse);
        if (loginResponse && loginResponse.data) {
            let keys = loginResponse.data;
            keys.forEach((key) => {
                let formattedKey = key.replace("_", " & "); // Changed underscore to ' & ' for better formatting
                if (formattedKey === "home") {
                    formattedKey = "Home Page Settings";
                }
                // if (formattedKey === "template") {
                //     formattedKey = "Utility Template Message";
                // }
                if (formattedKey === "userlogmaster") {
                    formattedKey = "User Log";
                }
                let icon = "";
                switch (key) {
                    case "user":
                        icon = "bi bi-person-fill";
                        break;
                    case "booking":
                        icon = "bi bi-truck";
                        break;
                    case "home":
                        icon = "bi bi-box-fill";
                        break;
                    case "template":
                        icon = "bi bi-file-earmark-text";
                        break;
                    case "userlog":
                        icon = "bi bi-people";
                        break;
                }

                this.sidebarItems.push({
                    name:
                        formattedKey.charAt(0).toUpperCase() +
                        formattedKey.substr(1).toLowerCase(),
                    link: "/" + key,
                    icon: icon,
                });
            });
        }

        const offcanvasElement = document.getElementById("offcanvasSidebar");
        const offcanvas = new Offcanvas(offcanvasElement, {
            backdrop: false,
        });
    },
    methods: {
        closeOffcanvas() {
            // Get the offcanvas element instance and hide it
            const offcanvasElement = document.getElementById("offcanvasSidebar");
            const offcanvas = Offcanvas.getInstance(offcanvasElement);
            if (offcanvas) {
                offcanvas.hide();
            }
        },

        logout() {
            localStorage.removeItem("email_id");
            localStorage.removeItem("loginresponse");
            caches
                .keys()
                .then((keyList) =>
                    Promise.all(keyList.map((key) => caches.delete(key)))
                );

            this.$router.push("/");
        },
    },
};
</script>

<style scoped>
/*
  The CSS you provided is generally fine, but I've made some minor tweaks for better readability and structure.
*/
.sidebar {
    z-index: 100;
    width: 300px;
    background-color: var(--sidebar-bg-color);
}

.offcanvas {
    background-color: #ff0800;
}

.offcanvas-backdrop {
    background-color: #ff0800cc !important;
}

.nav-link.active {
    background-color: #ffffff !important;
    color: var(--sidebar-bg-color) !important;
}

.active-link {
    background: rgba(255, 255, 255, 0.22);
    border-radius: 5px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(0.6px);
    -webkit-backdrop-filter: blur(0.6px);
    border: 1px solid rgba(255, 255, 255, 0.22);
    padding: 5px 20px 5px 0px;
    color: #ffffff;
}

.sidenav ul {
    padding-left: 0.5rem;
}

.sidenav {
    background-color: #f1f1f1 !important;
    height: 100% !important;
}

.sidenav li {
    list-style: none;
    padding: 5px 20px 5px 0px;
    font-family: displayregular;
    text-align: left;
    width: 100%;
}

.sidenav li a {
    text-decoration: none;
    color: #333333;
    font-size: 0.98rem;
    font-weight: 300;
    font-family: displayregular;
    display: block;
    padding: 5px 20px 5px 0px;
}

.sidenav li a:hover {
    background: rgba(255, 255, 255, 0.22);
    border-radius: 5px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(0.6px);
    -webkit-backdrop-filter: blur(0.6px);
    border: 1px solid rgba(255, 255, 255, 0.22);
    padding: 5px 20px 5px 0px;
    color: #ffffff;
}

.imge2 {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border-style: double;
    border-color: rgb(5, 68, 37);
}

.small-box {
    background-color: #ffffff;
    height: 70px;
    border: 1px solid #ebe7e7;
    right: 12px;
    position: absolute;
}

.small-box ul {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.small-box li {
    list-style: none;
    margin-right: 32px;
}

.small-box li a {
    color: #020b16;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.small-box li a:hover {
    background-color: #1a3077;
    padding: 8px;
    border-radius: 5px;
    color: #ffffff;
}

.email {
    margin-top: 10px;
}

@media screen and (max-width: 368px) {
    .sidenav {
        width: 100%;
        z-index: 1;
    }

    .router {
        margin-left: 250px;
    }
}
</style>
